var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"editable",staticClass:"wrap-it ce-paragraph ce-in",attrs:{"contenteditable":"true"},on:{"keydown":_vm.onKeyDown,"blur":_vm.update}})])}
var staticRenderFns = []

export { render, staticRenderFns }